import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import Layout from './components/Layout.vue';
import less from 'less'
import axios from 'axios'
import BaiduMap from 'vue-baidu-map'
// 网站置灰
// import './css/baseCss.css';
router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  console.log("beforeEach", to, from)
  next()
})
Vue.use(BaiduMap, {
  ak: 'YOUR_APP_KEY'
})
Vue.use(axios)
Vue.use(less)
Vue.use(ElementUI);

new Vue({
  el: '#app',
  router,
  render: h => h(Layout)
});
